import React, { Component } from "react";
import "./indicator.css";

export default class ProgressIndicator extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let indicator = this.props.show ? <div className="loader"></div> : null;
        return (indicator);
    }
}
